import { create } from "zustand";
import { persist } from "zustand/middleware";

type CameraState = {
  fov: number;
  targetFov: number | null;
  hasUserInteracted: boolean;
  setFov: (fov: number) => void;
  setTargetFov: (targetFov: number | null) => void;
  setHasUserInteracted: (hasInteracted: boolean) => void;
};

const getDefaultFov = (): number => {
  const isMobile = window.innerWidth < 768;
  return isMobile ? 105 : 75;
};

export const useCameraStore = create<CameraState>()(
  (set) => ({
    fov: getDefaultFov(),
    targetFov: null,
    hasUserInteracted: false,
    setFov: (fov) => set({ fov }),
    setTargetFov: (targetFov) => set({ targetFov }),
    setHasUserInteracted: (hasInteracted) =>
      set({ hasUserInteracted: hasInteracted }),
  }),
);
